export { default as Partners } from './Partners';
export { default as CaseStudy1 } from './CaseStudy1';
export { default as CaseStudy2 } from './CaseStudy2';
export { default as CaseStudy3 } from './CaseStudy3';
export { default as Hero } from './Hero';
export { default as Contact } from './Contact';
